export default "__VITE_ASSET__7c2d0742__"